<template>
  <v-btn
    class="button"
    :class="{
      'is-small': isSmall,
      'is-medium': isMedium,
      'is-nb-iot': isNbIot,
      'with-outline': withOutline,
      'has-padding': hasPadding || withOutline,
      'is-disabled': disabled,
      'is-light': isLight,
    }"
    :color="isWarning ? 'warning' : 'primary'"
    :loading="isLoading"
    :disabled="disabled"
    :to="to"
    depressed
    :text="isText"
    :height="height"
    @click="clickCallback"
  >
    {{ text }}
  </v-btn>
</template>
<script>
export default {
  name: 'ReelablesWebButton',
  props: {
    disabled: { type: Boolean, default: false },
    isLoading: { type: Boolean, default: false },
    text: { type: String, required: true },
    onClick: { type: Function, default: () => {} },
    isText: { type: Boolean, default: false },
    withOutline: { type: Boolean, default: false },
    isWarning: { type: Boolean, default: false },
    to: { type: Object, default: () => null },
    isSmall: { type: Boolean, default: false },
    isMedium: { type: Boolean, default: false },
    isNbIot: { type: Boolean, default: false },
    hasPadding: { type: Boolean, default: false },
    isLight: { type: Boolean, default: false },
  },
  computed: {
    height() {
      if (this.isSmall) return 25;
      if (this.isMedium) return 35;
      return this.$vuetify.breakpoint.mdAndUp ? 50 : 42;
    },
  },
  methods: {
    clickCallback() {
      this.$emit('click');
      if (typeof this.onClick === 'function'
        && !this.isLoading) this.onClick();
    },
  },
};
</script>
<style lang="scss">
@import '@/styles/_breakpoints.scss';
@import '@/styles/_variables.scss';

.button {
  text-transform: initial !important;
  border-radius: 0 !important;
  padding: 0 10px !important;

  @include mq($from: md) {
    min-width: 120px !important;
  }
  @include mq($from: lg) {
    &:not(.is-nb-iot) {
      padding: 0 30px !important;
    }
  }
  span {
    .v-btn__content {
      font-family: 'Bold-Font';
      font-size: 0.875rem;
      @include mq($from: md) {
        font-size: 1rem;
      }
    }
  }
  &.is-small {
    span.v-btn__content {
      font-size: 0.6875rem !important;
      @include mq($from: md) {
        font-size: 0.875rem !important;
      }
    }
  }
  &.is-nb-iot {
    border-radius: 5px !important;

    @include mq($from: md) {
      min-width: 60px !important;
    }
  }
  &.with-outline {
    border: 1px solid $gray1 !important;
    > span {
      color: $black !important;
    }
  }
  &.is-light {
    background-color: $white !important;
    color: $black !important;
    border: 1px solid $gray1 !important;
  }
  &.has-padding {
    > span {
      margin: 0 40px;
    }
    &.is-medium {
      > span {
        margin: 0 20px;
      }
    }
  }
  &.is-disabled {
    opacity: 0.5;
    pointer-events: none;
  }
}
</style>
